import React from 'react';
import '../css/Dashboard.css'
import axiosInstance from './config/axiosConfig';

export default function Dashboard() {
  // URL corregida para iframe embedding
  const embedUrl = "https://public.tableau.com/views/Gsan/GSANINFORMACION?:embed=yes&:display_count=no&:showVizHome=no&:toolbar=bottom";

  return (
    <div className="dashboard-container">
      <div className="tableau-container">
        <iframe
          src={embedUrl}
          width="100%"
          height="1200px"
          frameBorder="0"
          allowFullScreen
          scrolling="no"
          title="Tableau Dashboard - Gobernanza en SAN"
          style={{
            border: 'none',
            minHeight: '600px'
          }}
        />
      </div>
    </div>
  );
}
